import * as React from 'react';
import type {Except} from 'type-fest';

import type {StackProps} from '../_types';
import {useStack} from '../hooks';

import {HStackView} from '../Stack.styles';

/**
 * # HStack
 *
 * HStack creates a horizontal flowing `Stack` with spacing.
 *
 * ## Usage
 *
 * ```jsx
 * import { HStack } from "@packages/systems/spring";
 * import {SomeComponent} from '../SomeComponent';
 *
 * const Example = () => {
 *   return (
 *     <HStack>
 *       <SomeComponent>First</SomeComponent>
 *       <SomeComponent>Second</SomeComponent>
 *       <SomeComponent>Third</SomeComponent>
 *     </HStack>
 *   );
 * };
 * ```
 *
 * @component
 */
export const HStack = React.forwardRef<
  HTMLDivElement,
  Except<StackProps, 'direction'>
>(({align = 'center', ...props}, ref) => {
  const stackProps = useStack(props);

  return <HStackView {...stackProps} align={align} direction="row" ref={ref} />;
});

HStack.displayName = 'HStack';
HStack.toString = HStackView.toString;
